import EmojiWidget from "./EmojiWidget";

export default EmojiWidget;